import Vue from "vue";
import Router from "vue-router";
// import Home from "./components/Home.vue";
const Home = () => import("./components/Home.vue");
// import Gene from "./components/Gene.vue";
const Gene = () => import("./components/Gene.vue");
// import GeneDetail from "./components/GeneDetail.vue";
const GeneDetail = () => import("./components/GeneDetail.vue");
// import Pheno from "./components/Pheno.vue";
const Pheno = () => import("./components/Pheno.vue");
// const Pheno = r => require.ensure([], () => r(require('@/components/Pheno.vue')), 'index')
// import Skincare from "./components/Skincare.vue";
const Skincare = () => import("./components/Skincare.vue");
// import SkincareList from "./components/SkincareList.vue";
const SkincareList = () => import("./components/SkincareList.vue");
// import GeneAndSnp from "./components/GeneAndSnp.vue";
const GeneAndSnp = () => import("./components/GeneAndSnp.vue");
// import WhyDifferent from "./components/WhyDifferent.vue";
const WhyDifferent = () => import("./components/WhyDifferent.vue");
// import Skintype from "./components/Skintype.vue";
const Skintype = () => import("./components/Skintype.vue");
// import Barrier from "./components/Barrier.vue";
const Barrier = () => import("./components/Barrier.vue");
// import Melanin from "./components/Melanin.vue";
const Melanin = () => import("./components/Melanin.vue");
// import MoreServices from "./components/MoreServices.vue";
const MoreServices = () => import("./components/MoreServices.vue");
// import GeneCategory from "./components/GeneCategory.vue";
const GeneCategory = () => import("./components/GeneCategory.vue");
// import Romance from "./components/Romance.vue";
const Romance = () => import("./components/Romance.vue");
// import Share from "./components/Share.vue";
const Share = () => import("./components/Share.vue");
// import ShareActivity from "./components/ShareActivity.vue";
const ShareActivity = () => import("./components/ShareActivity.vue");
// import OfflineActivity from "./components/OfflineActivity.vue";
const OfflineActivity = () => import("./components/OfflineActivity.vue");
// import FatParticle from "./components/FatParticle.vue";
const FatParticle = () => import("./components/FatParticle.vue");
// import Peace from "./components/Peace.vue";
const Peace = () => import("./components/Peace.vue");
// import Fatness from "./components/Fatness.vue";
const Fatness = () => import("./components/Fatness.vue");
// import Pregnant from "./components/Pregnant.vue";
const Pregnant = () => import("./components/Pregnant.vue");
// import SkincareKeyPoints from "./components/SkincareKeyPoints.vue";
const SkincareKeyPoints = () => import("./components/SkincareKeyPoints.vue");
// import PoreSkincareGuide from "./components/PoreSkincareGuide.vue";
const PoreSkincareGuide = () => import("./components/PoreSkincareGuide.vue");
// import PoreGuideArea from "./components/PoreGuideArea.vue";
const PoreGuideArea = () => import("./components/PoreGuideArea.vue");
// import PoreGuideAreaDetail from "./components/PoreGuideAreaDetail.vue";
const PoreGuideAreaDetail = () => import("./components/PoreGuideAreaDetail.vue");
// import PoreGuideAreaDetailDescription from "./components/PoreGuideAreaDetailDescription.vue";
const PoreGuideAreaDetailDescription = () => import("./components/PoreGuideAreaDetailDescription.vue");
// import PoreGuideDetail from "./components/PoreGuideDetail.vue"
const PoreGuideDetail = () => import("./components/PoreGuideDetail.vue");
// import PoreSurvey from "./components/PoreSurvey.vue"
const PoreSurvey = () => import("./components/PoreSurvey.vue");
// import PoreSurveyEntry from "./components/PoreSurveyEntry.vue"
const PoreSurveyEntry = () => import("./components/PoreSurveyEntry.vue");
// import SunBlockGuide from "./components/SunBlockGuide.vue"
const SunBlockGuide = () => import("./components/SunBlockGuide.vue");
// import SunBlockSurvey from "./components/SunBlockSurvey.vue"
const SunBlockSurvey = () => import("./components/SunBlockSurvey.vue");
// import CleanserGuide from "./components/CleanserGuide.vue"
const CleanserGuide = () => import("./components/CleanserGuide.vue");
// import BlackheadsGuide from "./components/BlackheadsGuide.vue"
const BlackheadsGuide = () => import("./components/BlackheadsGuide.vue");
// import BlackheadsGuideDetail from "./components/BlackheadsGuideDetail.vue"
const BlackheadsGuideDetail = () => import("./components/BlackheadsGuideDetail.vue");
// import BlackheadsSurvey from "./components/BlackheadsSurvey.vue"
const BlackheadsSurvey = () => import("./components/BlackheadsSurvey.vue");
// import CleanserSurvey from "./components/CleanserSurvey.vue"
const CleanserSurvey = () => import("./components/CleanserSurvey.vue");
// import DesireToBuy from "./components/DesireToBuy.vue"
const DesireToBuy = () => import("./components/DesireToBuy.vue");
// import FruitFaceGuide from "./components/FruitFaceGuide.vue"
const FruitFaceGuide = () => import("./components/FruitFaceGuide.vue");
// import Double11PagePhenoTest from "./components/Double11PagePhenoTest.vue"
const Double11PagePhenoTest = () => import("./components/Double11PagePhenoTest.vue");
// import Double11PageProSet from "./components/Double11PageProSet.vue"
const Double11PageProSet = () => import("./components/Double11PageProSet.vue");
// import Double11Follow from "./components/Double11Follow.vue"
const Double11Follow = () => import("./components/Double11Follow.vue");
// import ScenarioMakeup from "./components/ScenarioMakeup.vue"
const ScenarioMakeup = () => import("./components/ScenarioMakeup.vue");
// import ScenarioMenstrual from "./components/ScenarioMenstrual.vue"
const ScenarioMenstrual = () => import("./components/ScenarioMenstrual.vue");
// import ScenarioTravel from "./components/ScenarioTravel.vue"
const ScenarioTravel = () => import("./components/ScenarioTravel.vue");
// import ScenarioOffice from "./components/ScenarioOffice.vue"
const ScenarioOffice = () => import("./components/ScenarioOffice.vue");

Vue.use(Router);

const router = new Router({
	// mode: 'history', //若开启，需要服务器支持虚拟路径，不然会出现404 ：https://www.cnblogs.com/kevingrace/p/6126762.html
	// base: getAbsolutePath(),
	scrollBehavior(to, from, savedPosition) {
		//router变化时滚动的位置
		return {
			x: 0,
			y: 0
		}
	},
	routes: [{
			path: '*',
			redirect: {
				name: 'Home'
			}
		},
		{
			path: "/",
			name: "Home",
			component: Home,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/gene",
			name: "Gene",
			component: Gene,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/genedetail/:typeid",
			name: "GeneDetail",
			component: GeneDetail,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/pheno/:bar_code?",
			name: "Pheno",
			component: Pheno,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/skintype/:bar_code?",
			name: "Skintype",
			component: Skintype,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/barrier/:bar_code?",
			name: "Barrier",
			component: Barrier,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/melanin/:bar_code?",
			name: "Melanin",
			component: Melanin,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/skincare",
			name: "Skincare",
			component: Skincare,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/skincarelist",
			name: "SkincareList",
			component: SkincareList,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/geneandsnp",
			name: "GeneAndSnp",
			component: GeneAndSnp,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/whydifferent",
			name: "WhyDifferent",
			component: WhyDifferent,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/moreservices",
			name: "MoreServices",
			component: MoreServices,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/genecategory",
			name: "GeneCategory",
			component: GeneCategory,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/romance",
			name: "Romance",
			component: Romance,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/share",
			name: "Share",
			component: Share,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/shareactivity",
			name: "ShareActivity",
			component: ShareActivity,
			meta:{
				title:"UNISKIN皮肤基因检测"
			}
		},
		{
			path: "/offlineactivity",
			name: "OfflineActivity",
			component: OfflineActivity,
			meta:{
				title:"UNISKIN皮肤基因检测"
			}
		},
		{
			path: "/fatparticle",
			name: "FatParticle",
			component: FatParticle,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/peace",
			name: "Peace",
			component: Peace,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/fatness",
			name: "Fatness",
			component: Fatness,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/pregnant",
			name: "Pregnant",
			component: Pregnant,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/skincarekeypoints",
			name: "SkincareKeyPoints",
			component: SkincareKeyPoints,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poreskincareguide",
			name: "PoreSkincareGuide",
			component: PoreSkincareGuide,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poreguidearea",
			name: "PoreGuideArea",
			component: PoreGuideArea,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poreguideareadetail",
			name: "PoreGuideAreaDetail",
			component: PoreGuideAreaDetail,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poreguideareadetaildescription",
			name: "PoreGuideAreaDetailDescription",
			component: PoreGuideAreaDetailDescription,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poreguidedetail",
			name: "PoreGuideDetail",
			component: PoreGuideDetail,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poresurvey",
			name: "PoreSurvey",
			component: PoreSurvey,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/poresurveyentry",
			name: "PoreSurveyEntry",
			component: PoreSurveyEntry,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/sunblockguide",
			name: "SunBlockGuide",
			component: SunBlockGuide,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/sunblocksurvey",
			name: "SunBlockSurvey",
			component: SunBlockSurvey,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/cleanserguide",
			name: "CleanserGuide",
			component:CleanserGuide,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/blackheadsguide",
			name: "BlackheadsGuide",
			component:BlackheadsGuide,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/blackheadsguidedetail",
			name: "BlackheadsGuideDetail",
			component:BlackheadsGuideDetail,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/blackheadssurvey",
			name: "BlackheadsSurvey",
			component:BlackheadsSurvey,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/cleansersurvey",
			name: "CleanserSurvey",
			component:CleanserSurvey,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/desiretobuy",
			name: "DesireToBuy",
			component:DesireToBuy,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/fruitfaceguide",
			name: "FruitFaceGuide",
			component:FruitFaceGuide,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/double11pagephenotest",
			name: "Double11PagePhenoTest",
			component:Double11PagePhenoTest,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/double11pageproset",
			name: "Double11PageProSet",
			component:Double11PageProSet,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/double11follow",
			name: "Double11Follow",
			component:Double11Follow,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/scenariomakeup",
			name: "ScenarioMakeup",
			component:ScenarioMakeup,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/scenariomenstrual",
			name: "ScenarioMenstrual",
			component:ScenarioMenstrual,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/scenariotravel",
			name: "ScenarioTravel",
			component:ScenarioTravel,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/scenariooffice",
			name: "ScenarioOffice",
			component:ScenarioOffice,
			meta:{
				title:"UNISKIN|检测报告"
			}
		},
		{
			path: "/about",
			name: "about",
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () =>
				import ( /* webpackChunkName: "about" */ "./views/About.vue")
		}
	]
});

export default router;
router.beforeEach((to, from, next) => {
	if(to.meta.title){
		document.title = to.meta.title;
	}
	if (location.search && (location.href.indexOf('/#/') == -1) && location.pathname && location.search) {
		// 重定向公众号入口地址参数，如：https://..reportMain.html?m=MDAw => https://..reportMain.html#/?m=MDAw
		console.log('beforeEach', location.origin + location.pathname + '#/' + location.search)
		location.href = location.origin + location.pathname + '#/' + location.search
	} else {
		next()
	}
})
router.afterEach((to, from) => {
	console.log(_hmt, to)
	if (_hmt) {
		if (to.path) {
			_hmt.push(['_trackPageview', '/#' + to.fullPath]);
		}
	}
})